import { COOKIE_STORAGE } from '@helpers';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import storeKeys from './storeKeys';
import { LoadingState } from './types';

export const initialState = storeKeys.reduce(
    (acc, curr) => ({
        ...acc,
        [curr]: {
            isLoading: false,
        },
    }),
    {} as LoadingState,
);

const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        loading(state, payload: PayloadAction<void>) {
            const apiCallMatch = /@@(.*)\/FETCH/.exec(payload.type),
                //storeKey = apiCallMatch && apiCallMatch[1];
                storeKey = apiCallMatch && 'api';

            switch (true) {
                case /.*FETCH_\w*REQUEST/.test(payload.type):
                    state[storeKey as string].isLoading = false;
                    break;

                case /.*FETCH_SUCCESS/.test(payload.type):
                case /.*FETCH_FAILURE/.test(payload.type):
                    state[storeKey as string].isLoading = false;
                    break;
                case /LOGOUT/.test(payload.type):
                    COOKIE_STORAGE.removeItem('applicationAuth');
                    window.location.href = '/login';
                    break;
                default:
            }
        },
    },
});

export const { loading } = loadingSlice.actions;

export default loadingSlice.reducer;
